"use client";

import {Box, ColorPalette, Flex, HStack, Input, Stack, StackProps, useBreakpointValue} from "@chakra-ui/react";

const TriButton = ({scale, colorPalette}: {scale: number; colorPalette: ColorPalette}) => (
  <Box
    colorPalette={colorPalette}
    rounded="full"
    bg="colorPalette.500"
    border="1px solid {colors.colorPalette.600/50}"
    w={`${scale * 25}px`}
    h={`${scale * 25}px`}
    flexShrink={0}
  />
);

type SIZE = "md" | "sm" | "xs";

const BrowserChrome = ({size = "md", children, ...props}: {size?: SIZE | SIZE[]} & StackProps) => {
  // Always call the hook, then decide how to use the result
  const sizeArray = Array.isArray(size) ? size : [size];
  const defaultSize = sizeArray[0] || "md";

  const breakpointValue = useBreakpointValue(
    {
      base: sizeArray[0] || "md",
      sm: sizeArray[1] || sizeArray[0] || "md",
      md: sizeArray[2] || sizeArray[1] || sizeArray[0] || "md",
      lg: sizeArray[3] || sizeArray[2] || sizeArray[1] || sizeArray[0] || "md",
      xl: sizeArray[4] || sizeArray[3] || sizeArray[2] || sizeArray[1] || sizeArray[0] || "md",
      "2xl": sizeArray[5] || sizeArray[4] || sizeArray[3] || sizeArray[2] || sizeArray[1] || sizeArray[0] || "md",
    },
    {fallback: defaultSize},
  );

  const responsiveSize: SIZE = Array.isArray(size) ? breakpointValue || defaultSize : size;

  const scale = responsiveSize === "md" ? 0.4 : responsiveSize === "sm" ? 0.3 : 0.2;

  return (
    <Stack {...props} gap={0} align="stretch" rounded={responsiveSize} overflow="hidden">
      <HStack bg="gray.200" px={`${scale * 25}px`} py={`${scale * 15}px`} gap={`${scale * 20}px`}>
        <HStack gap={`${scale * 10}px`} flex={1} justify="flex-start">
          <TriButton scale={scale} colorPalette="red" />
          <TriButton scale={scale} colorPalette="yellow" />
          <TriButton scale={scale} colorPalette="green" />
        </HStack>
        {responsiveSize == "xs" ? (
          <Flex align="center" bg="white" h={3} flex={3} border="1px solid {colors.gray.300/50}" rounded="xs" px={1.5}>
            <Box bg="gray.300" h={1} w="33%" />
          </Flex>
        ) : (
          <Input
            flex={3}
            value="https://app.platformed.com"
            bg="white"
            h={responsiveSize == "sm" ? 6 : "none"}
            fontSize={responsiveSize == "md" ? "xs" : "2xs"}
            size="2xs"
            border="1px solid {colors.gray.300}"
            color="gray.600"
            pointerEvents="none"
            readOnly
          />
        )}
        <Box flex={1} />
      </HStack>
      {children}
    </Stack>
  );
};

export default BrowserChrome;
